export const LOCAL_STORAGE_KEY_FONT_SIZE = 'lyrics-font-size';
export const CSS_VARIABLE_FONT_SIZE = '--lyrics-font-size';

export const MIN_FONT_SIZE = 12;
export const MAX_FONT_SIZE = 48;
export const DEFAULT_FONT_SIZE = 20;